import React from "react";

import TextAttributeForm from "../../../../components/AttributeForm/TextAttributeForm";
import {useApartment} from "./ApartmentContext";
import {useApartmentAction} from "./ApartmentActionContext";
import {nameValidationSchema} from "./apartmentValidationSchema";

import Card from "@mui/material/Card";
import AvatarWithUpload from "../../../../components/AvatarWithUpload";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import ButtonBase from "@mui/material/ButtonBase";
import Typography from "@mui/material/Typography";
import EditIcon from "@mui/icons-material/Edit";
import ScoreWarning from "../../ScoreWarning";


const ApartmentHeader = () => {
    const {name, beds, sofaBeds, extraBeds, infoScore, icon, updateIcon} = useApartment();
    const {formName, handleAttributeUpdate} = useApartmentAction();

    const people = beds + sofaBeds + extraBeds;
    const peopleLine = people === 1 ? `1 persona` : `${people} persone`;

    const scoreColor = infoScore.missingAttribute.length > 0 ? "warning.main" : "success.main";
    const initialLetter = name ? name.charAt(0) : "A";

    return <Card sx={{mt: {md: 3}}}>
        <CardContent>
            <Stack spacing={2}>
                <Stack direction="row" gap="24px">

                    <AvatarWithUpload imgAlt={name} imgSrc={icon} width="120px" height="120px" onUpdate={updateIcon} variant="rounded">
                        {initialLetter}
                    </AvatarWithUpload>

                    <Stack direction='column' justifyContent='space-between' flexGrow={1} spacing={2}>
                        <Stack direction='column'>

                            <ButtonBase onClick={formName.open}>
                                <Stack direction="row" justifyContent="space-between" alignItems="center" flexGrow={1}>
                                    <Typography variant="h4" textAlign="left">{name}</Typography>
                                    <EditIcon/>
                                </Stack>
                            </ButtonBase>

                            <Typography variant="subtitle1">{peopleLine}</Typography>
                        </Stack>
                        <Typography variant="subtitle2" color={scoreColor}>
                            {`Punteggio: ${infoScore.score}`}
                        </Typography>
                    </Stack>

                </Stack>
                {
                    infoScore.missingAttribute.length > 0 && <ScoreWarning attributes={infoScore.missingAttribute}/>
                }
                {
                    formName.show && <TextAttributeForm attribute="name"
                                                        label="Nome"
                                                        value={name}
                                                        validationSchema={nameValidationSchema}
                                                        onClose={formName.close}
                                                        onSubmit={(data) => handleAttributeUpdate(formName, data)}
                                                        isLoading={formName.loading}/>
                }
            </Stack>
        </CardContent>
    </Card>
}

export default ApartmentHeader;